import Vue from "vue"
import _ from "lodash"
import { FILTER_CATEGORIES } from "./coach-filters.constants"

const state = () => ({
  filterDrawerCollapsed: true,
  selectedFilters: {},
  searchQueryValue: "",
})

const mutations = {
  SET_FILTER_DRAWER_COLLAPSED: (state, collapsed) => {
    state.filterDrawerCollapsed = collapsed
  },
  TOGGLE_SELECTED_FILTER: (state, { category, option }) => {
    if (!(category in state.selectedFilters)) {
      Vue.set(state.selectedFilters, category, {})
    }
    const optionKey = option.key
    if (optionKey in state.selectedFilters[category]) {
      Vue.delete(state.selectedFilters[category], optionKey)
    } else {
      Vue.set(state.selectedFilters[category], optionKey, option)
    }
  },
  RESET_FILTERS: (state) => {
    state.selectedFilters = {}
  },
  SET_SEARCH_QUERY_VALUE: (state, value) => {
    state.searchQueryValue = value
  },
}

const actions = {
  toggleFilterDrawerCollapse ({ state, commit }, collapse) {
    commit("SET_FILTER_DRAWER_COLLAPSED", _.isNil(collapse) ? !state.filterDrawerCollapsed : !!collapse)
  },
  toggleSelectedRegionFilter ({ commit }, option) {
    commit("TOGGLE_SELECTED_FILTER", {
      category: FILTER_CATEGORIES.REGION,
      option: option,
    })
  },
  toggleSelectedLanguageFilter ({ commit }, option) {
    commit("TOGGLE_SELECTED_FILTER", {
      category: FILTER_CATEGORIES.LANGUAGE,
      option: option,
    })
  },
  toggleSelectedPlatformFilter ({ commit }, option) {
    commit("TOGGLE_SELECTED_FILTER", {
      category: FILTER_CATEGORIES.PLATFORM,
      option: option,
    })
  },
  toggleSelectedRankFilter ({ commit }, option) {
    commit("TOGGLE_SELECTED_FILTER", {
      category: FILTER_CATEGORIES.RANK,
      option: option,
    })
  },
  toggleSelectedSpecialtyFilter ({ commit }, option) {
    commit("TOGGLE_SELECTED_FILTER", {
      category: FILTER_CATEGORIES.SPECIALTY,
      option: option,
    })
  },
  toggleSelectedPriceFilter ({ commit }, option) {
    commit("TOGGLE_SELECTED_FILTER", {
      category: FILTER_CATEGORIES.PRICE,
      option: option,
    })
  },
  resetFilters ({ commit }) {
    commit("RESET_FILTERS")
  },
  setSearchQueryValue ({ commit }, value) {
    commit("SET_SEARCH_QUERY_VALUE", value)
  },
}

const getters = {
  filterDrawerCollapsed: state => state.filterDrawerCollapsed,
  selectedFilterRegions: state => state.selectedFilters[FILTER_CATEGORIES.REGION] || {},
  selectedFilterLanguages: state => state.selectedFilters[FILTER_CATEGORIES.LANGUAGE] || {},
  selectedFilterPlatforms: state => state.selectedFilters[FILTER_CATEGORIES.PLATFORM] || {},
  selectedFilterRanks: state => state.selectedFilters[FILTER_CATEGORIES.RANK] || {},
  selectedFilterSpecialties: state => state.selectedFilters[FILTER_CATEGORIES.SPECIALTY] || {},
  selectedFilterPrices: state => state.selectedFilters[FILTER_CATEGORIES.PRICE] || {},
  areFiltersSelected: state => {
    return Object.values(state.selectedFilters).reduce((hasFilters, filters) => {
      return hasFilters || Object.keys(filters).length > 0
    }, false)
  },
  searchQueryValue: state => state.searchQueryValue,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/coaching/widget/coach-filters/coach-filters.module.js